export function removeItemArray() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var index = arguments[1];

    var array = [].concat(list);
    array.splice(index, 1);

    return array;
}

export function transformArrayToString() {
    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return Array.isArray(array) ? array.join(',') : '';
}

export function sortArray() {
    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var func = arguments[1];

    var newArray = [].concat(array);

    newArray.sort(func);

    return newArray;
}